import { readable, writable } from 'svelte/store';
import { get } from 'svelte/store';
import { writable as localWritable } from 'Services/localStorage';

export let CLOSE_MENU = readable(1200); // Screen width where the booking list is close by default

export let SCREEN_SIZES = readable({ xs: 400, sm: 600, md: 800, xl: 1030, xxl: 1200 });
export let triggerMediaQuery = writable({ xs: false, sm: false, md: false, xl: false, xxl: false });

export let showSidebar = writable(false);
export let headerMobileSearch = writable({ show: false, triggered: false });
export let apiError = writable({
	show: false,
	message: null,
	code: null
});

/* The server will call the endpoints to fill those data */
export let userInfo = writable({});
export const isAdmin = readable(() => {
	return ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_TELEPRO'].some((role) =>
		get(userInfo)?.roles?.includes(role)
	);
});
export const isRestaurant = readable(() => {
	return get(userInfo)?.roles?.includes('ROLE_RESTAURANT');
});
export const isCommercial = readable(() => {
	return (
		get(userInfo)?.roles?.includes('ROLE_COMMERCIAL') ||
		get(userInfo)?.roles?.includes('ROLE_TELEPRO')
	);
});

// Bearer store here because cant access context in js files
export let bearerToken = writable();
export let restaurantToken = writable(null);

export let offlineMode = writable(null);

export let currentRestaurant = writable();
export let currentDevice = writable(null);
export let isMobileMenuClosed = writable(false);

export let showSidebarSearch = localWritable({ showSidebarSearch: false }, 'sidebar');

export let closeSidebarResponsive = writable(false);

export let rememberMe = writable(null);
export let phpSessId = writable(null);

// Return the stripe fees for a given amount
export const getStripeFees = (amount) => {
	const STRIPE_FLAT_TAX = 0.25;
	const STRIPE_PURCENT_TAX = 0.015;

	return amount * STRIPE_PURCENT_TAX + STRIPE_FLAT_TAX;
};
